import { appNotification } from "../components/common/notification";
import { GENERAL_SERVER_ERROR } from "../constants/config";


export const getAgentsConfigs = (): Promise<Agent[] | null> => {
    return fetch(import.meta.env.VITE_API_BASE_URL + '/system/options/agents', 
        { credentials: "include" })
    .then((res) => {
        if (res.status === 401) {
            window.location.href = '/login';
        }
        return res.json();
    }).then((data) => {
        if (data.detail) {
            appNotification.error({ message: "Retrieving system options:", description: data.detail });
            return null
        }
        else {
            return data.data as Agent[]
        }
    }).catch((err) => {
        appNotification.error({ message: "Retrieving system options:", description: GENERAL_SERVER_ERROR });
        return null
    });
}